











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class TrustpilotRating extends Vue {
  @Prop({ type: Boolean, default: false }) private readonly isExperiment!: boolean;
}
